module.exports = __webpack_public_path__ + "static/media/Support Icon.4784c2d8.svg";